@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.banner {
    --banner-link-color: var(--banner-link-blue);
    background-color: var(--banner-blue-01);
    font-size: 16px;
    padding: 10px 0px;
    text-align: center;
    color: white;

    a {
        line-height: inherit;
        color: var(--banner-link-color, currentColor);
        text-decoration: underline;
        cursor: pointer;
        font-weight: normal;
    }
}

.navy {
  background-color:var(--blue-00);
  a {
    color:var(--highlight-blue-02);
  }
}

.lightblue {
  background-color:var(--highlight-blue-02);
  a {
    color:var(--blue-00);
  }
}

.paleblue {
  background-color: var(--banner-blue-02);
  a {
    color:var(--blue-00);
  }
}

.october {
  background-color: var(--banner-blue-03);
  height: 40px;
  font-size: 16px;
  color: var(--pure-black);
}


.black {
  background-color: black;
  height: 40px;
  font-size: 16px;
}

.october {
  background-color: var(--banner-blue-03);
  height: 40px;
  font-size: 16px;
  color: var(--pure-black);
}

.bannerFont{
  font-family: typography.$font-mont;
}